/** @jsx jsx */

import { createKeyHandler } from '@zapier/common-utils';
import { Colors, Spacer, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import SidebarButton from './Button';

type Props = {
  onBack?: () => void;
  onClose: () => void;
  onHome?: () => void;
  title: string;
};

const Styles = {
  root: css`
    display: flex;
    align-items: center;
    background: ${Colors.GrayWarm2};
    padding: 15px;
    border-bottom: 1px solid ${Colors.GrayWarm3};
    width: 100%;
    z-index: 10;
  `,
  titleLink: css`
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  `,
  titleWrapper: css`
    flex-grow: 1;
    align-self: stretch;
    display: flex;
    align-items: center;
  `,
};

const Header = (props: Props) => {
  const { onBack, onClose, onHome, title } = props;

  const renderTitle = () => {
    const text = <Text fontWeight={600}>{title}</Text>;

    return onHome ? (
      <div
        css={Styles.titleLink}
        onClick={onHome}
        onKeyDown={createKeyHandler(['enter'], onHome)}
        role="button"
        tabIndex={0}
      >
        {text}
      </div>
    ) : (
      <div>{text}</div>
    );
  };

  return (
    <header css={Styles.root}>
      <div css={Styles.titleWrapper}>
        {onBack && (
          <SidebarButton
            label="go back"
            name="arrowSmallLeft"
            onClick={onBack}
          />
        )}
        <Spacer width={10} />
        {renderTitle()}
      </div>
      <SidebarButton label="close sidebar" name="formX" onClick={onClose} />
    </header>
  );
};

export default Header;
